module.exports = __webpack_public_path__ + "static/mid_text-7beaaec7318f38a5d99f76e616d73b7b.png";